import { format, isSameDay } from "date-fns";
import { toZonedTime } from "date-fns-tz";

import { timeZoneCodeOrDefault } from "~/screens/Scheduling/InitialVisit/utils/date-time-utils";

const JOIN_BUTTON_OPEN_HOUR = 7;

export const formatVisitDate = (iso: string, timezone: string): string => {
  const zoned = toZonedTime(new Date(iso), timezone);
  return `${format(zoned, "EEE, MMMM d")} | ${format(zoned, "h:mm a")} (${timeZoneCodeOrDefault(timezone)})`;
};

export const formatLinkAvailableDate = (
  iso: string,
  timezone: string,
): string => format(toZonedTime(new Date(iso), timezone), "M/d");

export const isVisitJoinable = (
  iso: string,
  timezone: string,
  now: Date = new Date(),
): boolean => {
  const visit = toZonedTime(new Date(iso), timezone);
  const current = toZonedTime(now, timezone);
  if (!isSameDay(visit, current)) return false;
  return current.getHours() >= JOIN_BUTTON_OPEN_HOUR;
};
